import React, { useState } from "react";
import moment from "moment";
import CompanyDashboardAddObjectivePopup from "./company-dashboard-initiative-drawer-side-bar-objectives-popup";
import { Box, CircularProgress, Typography } from "@mui/material";
import { getProgressColor } from "../../../company-dashboard-utils";

import "./company-dashboard-initiative-drawer-side-bar.scss";

const CompanyDashboardInitiativeDrawerSideBarObjectives: any = (props: any) => {
  const {
    employeesList,
    objectiveId,
    setObjectiveId,
    newObjectiveData,
    setNewObjectiveData,
    statusListObjectives,
    fetchInitiatives,
    setAlertType,
    setAlertOpen,
    setLoading,
    setAlertMessage,
    updateInitiativeById,
    setIsShowInitiativeDrawer,
    canEdit,
    initiativeDataPermissions,
    initiativeId,
  } = props;

  const [isOpenAddObjectivePopup, setIsOpenAddObjectivePopup] = useState(false);
  const handleOpenAddObjectivePopup = () => {
    setIsOpenAddObjectivePopup(true);
    setIsShowInitiativeDrawer(false);
    setObjectiveId("Objectives");
  };

  const handleCloseAddObjectivePopup = () => {
    setIsOpenAddObjectivePopup(false);
  };

  return (
    <>
      <div className="company-dashboard-initiative-drawer-side-bar-content-header">
        <div>Objectives</div>
      </div>
      {newObjectiveData?.length ? (
        newObjectiveData?.map((obj: any, index: number) => (
          <div
            className="company-dashboard-all-objective-drawer-side-bar-content-details"
            style={{
              borderBottom: `3px solid ${getProgressColor(obj?.status).mainColor}`,
            }}
            key={index + 1}
          >
            <div className="company-dashboard-all-objective-drawer-side-bar-content-details-content">
              <div>
                <div className="company-dashboard-all-objective-drawer-side-bar-content-details-content-main-label">
                  {obj?.objectiveName}
                </div>
                <div className="company-dashboard-all-objective-drawer-side-bar-content-details-content-sub-label">
                  Last Updated: {moment(obj?.startDate).format("MM-DD-YYYY")}
                </div>
              </div>
              <div className="company-dashboard-all-objective-drawer-side-bar-content-details-content-graph">
                <Box sx={{ position: "relative", display: "inline-flex" }}>
                  <CircularProgress
                    variant="determinate"
                    value={100}
                    size={72}
                    thickness={6.2}
                    sx={{
                      color: getProgressColor(obj?.status).lightColor,
                    }}
                  />
                  <CircularProgress
                    variant="determinate"
                    value={obj?.weightage}
                    size={72}
                    sx={{
                      color: getProgressColor(obj?.status).mainColor,
                      "& .MuiCircularProgress-circle": {
                        strokeLinecap: "round",
                      },
                      position: "absolute",
                      left: 0,
                    }}
                    thickness={6.2}
                  />
                  <Box
                    sx={{
                      top: 0,
                      left: 0,
                      bottom: 0,
                      right: 0,
                      position: "absolute",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                    }}
                  >
                    <Typography
                      variant="caption"
                      component="div"
                      sx={{ color: "#403C6F" }}
                    >{`${Math.round(obj?.weightage || 0)}%`}</Typography>
                  </Box>
                </Box>
              </div>
            </div>
          </div>
        ))
      ) : (
        <div className="company-dashboard-all-objective-add-drawer-side-bar-add-content-key-results">
          <div className="company-dashboard-all-objective-add-drawer-side-bar-add-content-key-results-content">
            <div className="company-dashboard-all-objective-add-drawer-side-bar-add-content-key-results-content-label">
              You don't have any Objectives yet
            </div>
            {(canEdit && initiativeDataPermissions) || !initiativeId ? (
              <div className="company-dashboard-all-objective-add-drawer-side-bar-add-content-key-results-content-button">
                <button
                  onClick={handleOpenAddObjectivePopup}
                  style={{ cursor: "pointer" }}
                >
                  Add New Objectives
                </button>
              </div>
            ) : (
              ""
            )}
          </div>
        </div>
      )}
      {isOpenAddObjectivePopup ? (
        <CompanyDashboardAddObjectivePopup
          isOpenAddPopup={isOpenAddObjectivePopup}
          onCancel={handleCloseAddObjectivePopup}
          newObjectiveData={newObjectiveData}
          setNewObjectiveData={setNewObjectiveData}
          employeesList={employeesList}
          statusListObjectives={statusListObjectives}
          fetchInitiatives={fetchInitiatives}
          setAlertType={setAlertType}
          setAlertOpen={setAlertOpen}
          setLoading={setLoading}
          setAlertMessage={setAlertMessage}
          setObjectiveId={setObjectiveId}
          objectiveId={objectiveId}
          updateInitiativeById={updateInitiativeById}
        />
      ) : (
        ""
      )}
    </>
  );
};

export default CompanyDashboardInitiativeDrawerSideBarObjectives;
